import { cropUrl } from './images.js'

export const GALLERY_DIMENSIONS = { width: 520, height: 520 }

export const GALLERY_MOBILE_WIDTH = 400

const GALLERY_MOBILE_WIDTHS = [320, GALLERY_MOBILE_WIDTH, 800]

const GALLERY_QUALITY = 86

export function galleryCrop(media, width, height, contain) {
  return cropUrl(
    media?.image ?? media,
    width,
    contain ? '_' : height,
    media?.image?.extension ?? media?.extension,
    GALLERY_QUALITY
  )
}

export function galleryMobileSrcset(media, contain) {
  return GALLERY_MOBILE_WIDTHS.map(
    width => `${galleryCrop(media, width, width, contain)} ${width}w`
  ).join(', ')
}

export function galleryMainSrcset(media, dimensions, contain) {
  return `${galleryCrop(
    media,
    dimensions.width * 2,
    dimensions.height * 2,
    contain
  )} 2x`
}

export function galleryImagePreload(media, { isMobile, contain }) {
  if (!(media?.image ?? media)?.url) {
    return null
  }

  if (isMobile) {
    return {
      href: galleryCrop(
        media,
        GALLERY_MOBILE_WIDTH,
        GALLERY_MOBILE_WIDTH,
        contain
      ),
      imagesrcset: galleryMobileSrcset(media, contain),
      imagesizes: '100vw',
    }
  }

  const href = galleryCrop(
    media,
    GALLERY_DIMENSIONS.width,
    GALLERY_DIMENSIONS.height,
    contain
  )
  return {
    href,
    imagesrcset: `${href} 1x, ${galleryMainSrcset(
      media,
      GALLERY_DIMENSIONS,
      contain
    )}`,
  }
}
